import React from "react";
import { connect } from "react-redux";
import { TabletOrDesktop, Mobile } from "utils/responsive";
import Layout from "components/Layout";
import Modal from "components/Modal";
import Expenses from "pages/Expenses";
import MobileExpensesView from "components/Expenses/Mobile/MobileExpensesView";
import { hideModal } from "actions/modalActions";

/**
 * Tablet/desktop: listado clásico. Móvil (menos de 768px de ancho): vista tipo supervisión de fichajes.
 */
const ExpensesResponsive = ({ hideModal }) => (
	<>
		<TabletOrDesktop>
			<Expenses />
		</TabletOrDesktop>
		<Mobile>
			<>
				<Layout className="page-expenses mobile" context="expenses">
					<MobileExpensesView />
				</Layout>
				<Modal hideModal={hideModal} />
			</>
		</Mobile>
	</>
);

export default connect(null, { hideModal })(ExpensesResponsive);
